import React, { Component } from "react";
import { Comment, Icon, Form, Grid, Message, Segment } from "semantic-ui-react";
import uniq from "lodash/uniq";

import request from "../../utils/request";

const resetState = props => {
  return {
    eventId: props.match.params.id,
    isMounted: false,
    poll: false,
    formLoading: false,
    messages: [],
    sellers: [{ text: "@All", value: "all" }],
    recipients: [],
    unread: [],
    xhrResponse: {
      success: null,
      message: ""
    },
  };
};

class MessagesTab extends Component {
  constructor(props) {
    super(props);
    this.state = resetState(this.props);
  }
  componentDidMount = () => {
    setTimeout(this.poll, 500);
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      clearInterval(this.state.poll);
      setTimeout(this.poll, 500);
    }
  };
  componentWillUnmount = () => {
    clearInterval(this.state.poll);
    this.setState({ poll: false });
  };
  poll = () => {
    this.requestData();
    let pollInterval = setInterval(this.requestData, 30000);
    this.setState({
      poll: pollInterval
    });
  };
  requestData = () => {
    if (!this.state.eventId) return false;

    let promises = [
      request.get(this, `api:/event/${this.state.eventId}/messages`, {}),
      request.get(this, `api:/event-sellers/${this.state.eventId}`, {})
    ];

    let self = this;
    Promise.all(promises).then(function (values) {
      if (values && values[0] && values[1]) {
        self.setState({
          messages: values[0]
        });
        self.parseSellers(values[1]);
      }

      self.setState({ isLoading: false });
    });
  };
  parseSellers = sellers => {
    let result = [{ key: "all", text: "@All", value: "all" }];
    sellers.data.map((value, index) => {
      if (+value.volunteer_id === 50000 || value.login === "shopify") return false;
      return result.push({
        key: index,
        text: value.volunteer,
        value: value.volunteer_id
      });
    });
    this.setState({
      sellers: result
    });
    return result;
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleReply = e => {
    let recipient = e.target.id;
    let recipients = this.state.recipients;
    recipients.push(+recipient);
    let result = uniq(recipients);
    this.setState({
      recipients: result
    });
  };
  handleSubmit = e => {
    this.setState({
      formLoading: true, 
      xhrResponse: {
        success: null,
        message: ""
      },
    });
    var self = this;
    var payload = {
      text: this.state.message,
      sellers: this.state.recipients
    };

    return request.post(this, `api:/event/${this.state.eventId}/messages`, payload).then(resp => {
      this.setState({ formLoading: false, xhrResponse: resp });

      if (typeof resp !== "undefined" && resp.status === "success") {
        self.setState({
          recipients: [],
          message: "",
          errorShow: false,
          errorList: [],
          successShow: true,
          successMessage: resp.message
        });
      }
      self.requestData();
    });
  };
  markAsRead = e => {
    var self = this;
    return request.put(this, `api:/event/${this.state.eventId}/messages/${e.target.id}`, {}).then(resp => {
      self.requestData();
    });
  };
  handleColor = value => {
    if (value.type === "from_ipad" && value.status === "sent") return "red";
    else if (value.status === "read") return "grey";
    else return "blue";
  };
  render() {
    const { formLoading, messages, recipients, message, sellers, xhrResponse } = this.state;
    return (
      <Segment basic>
        <Grid stackable>
          {messages &&
            <Grid.Column width={6}>
            {messages.length === 0 || (messages.status && messages.status === "error") ? (
              <Comment.Group id="messages">
                <Comment content="No Messages" />
              </Comment.Group>
            ) : (
                <Comment.Group id="messages">
                  {messages.map((value, index) => (
                    <Comment key={index}>
                      <Comment.Avatar
                        as={Icon}
                        name="circle"
                        color={this.handleColor(value)}
                        size="large"
                      />
                      <Comment.Content>
                        <div style={{ float: "right" }}>
                          <Icon
                            color={value.type === "from_ipad" ? "red" : "blue"}
                            name={
                              value.type === "from_ipad"
                                ? "tablet alternate"
                                : "user"
                            }
                          />
                          <Icon
                            color={value.type === "from_ipad" ? "red" : "blue"}
                            name="arrow right"
                          />
                          <Icon
                            color={value.type === "from_ipad" ? "red" : "blue"}
                            name={
                              value.type === "from_ipad"
                                ? "user"
                                : "tablet alternate"
                            }
                          />
                        </div>
                        <Comment.Author
                          as="a"
                          id={value.volunteer_id}
                          onClick={this.handleReply}
                        >
                          {value.title}
                        </Comment.Author>
                        <br />
                        <Comment.Metadata style={{ marginLeft: 0 }}>
                          <span>
                            {value.time}
                          </span>
                        </Comment.Metadata>
                        <Comment.Text>{value.text}</Comment.Text>
                        <Comment.Actions>
                          {value.type === "from_ipad" &&
                            value.status === "sent" ? (
                              <Comment.Action
                                content="Mark as read"
                                id={value.id}
                                onClick={this.markAsRead}
                              />
                            ) : (
                              ""
                            )}
                          <Comment.Action
                            content="Reply"
                            id={value.volunteer_id}
                            onClick={this.handleReply}
                          />
                        </Comment.Actions>
                      </Comment.Content>
                    </Comment>
                  ))}
                </Comment.Group>
              )}
          </Grid.Column>
          }
          <Grid.Column width={10}>
            <h3>Send Message</h3>
            <Form
              id="messageForm"
              loading={formLoading}
              success={xhrResponse.success === true}
              error={!xhrResponse.success && xhrResponse.success !== null}
            >
              <Message success content={xhrResponse.message} />
              <Message error content={xhrResponse.message} />
              <Form.Select
                name="recipients"
                fluid
                label="To"
                placeholder="To"
                multiple
                search
                options={sellers}
                value={recipients}
                onChange={this.handleChange}
              />
              <Form.TextArea
                name="message"
                label="Message"
                placeholder="Notes..."
                value={message}
                onChange={this.handleChange}
              />
              <Form.Button loading={formLoading} onClick={this.handleSubmit}>
                <Icon name="paper plane" /> Send
              </Form.Button>
            </Form>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default MessagesTab;
